import { ContentfulApi, ContentfulContext } from './contentful-library.model';

export const contentfulConfig: Record<ContentfulContext, ContentfulApi> = {
  [ContentfulContext.STAGING]: {
    space: 'r9p6j404vvxj',
    host: 'preview.contentful.com',
    accessToken: 'BAMpIe91nVvL6WTuHVuv6ryscNWTXuVWy39bel2fJnQ',
  },
  [ContentfulContext.PRODUCTION]: {
    space: 'r9p6j404vvxj',
    host: 'cdn.contentful.com',
    accessToken: 'YIQiff5e0o9rcnhCsTT4SGBDSBHNMrBKbHZNYVeQ-Bk',
  },
};
